/* RESPONSIBLE TEAM: team-phone */
import Step, { IsCustomerFacing } from 'embercom/models/operator/visual-builder/step';
import { attr } from '@ember-data/model';
import type Store from '@ember-data/store';
import { buildValidations, validator } from 'ember-cp-validations';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
const Validations = buildValidations({
  triggerableWorkflowId: [
    validator('presence', {
      presence: true,
      messageKey: 'operator.workflows.visual-builder.validations.content-is-missing',
    }),
  ],
  compatibleChannels: [validator('trigger-workflow-channel-compatibility')],
  compatibleWithBackgroundOnlyBots: [
    validator('trigger-workflow-background-only-bot-compatibility'),
  ],
});

export default class TriggerPhoneReusableWorkflow extends Step.extend(Validations) {
  @attr('number') declare triggerableWorkflowId?: number;
  @attr('array') declare compatibleChannels?: string[];
  @attr('boolean') declare userVisible: boolean;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.triggerPhoneReusableWorkflow;
  }

  static get isStepGroupEnding() {
    return false;
  }

  static createNewStep(store: Store): TriggerPhoneReusableWorkflow {
    return store.createRecord('operator/visual-builder/step/trigger-phone-reusable-workflow', {
      type: 'operator/visual-builder/step/trigger-phone-reusable-workflow',
    });
  }

  static get canBeCustomerFacing() {
    return IsCustomerFacing.Maybe;
  }
}
